import EnglishContent from "../config/EN";
import SpanishContent from "../config/ES";

const LanguageReducer = (state, action) => {

  switch (action.language) {
    case "en": {
      return {
        language: "en",
        content: EnglishContent,
      }
    }
    case "es": {
      return {
        language: "es",
        content: SpanishContent,
      }
    }
    default:
      return state;
  }
}

export default LanguageReducer;